import { render, staticRenderFns } from "./LogisticsInfoModal.vue?vue&type=template&id=53372744&scoped=true"
import script from "./LogisticsInfoModal.vue?vue&type=script&lang=js"
export * from "./LogisticsInfoModal.vue?vue&type=script&lang=js"
import style0 from "./LogisticsInfoModal.vue?vue&type=style&index=0&id=53372744&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53372744",
  null
  
)

export default component.exports